import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// PrimeReact Components
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { Toast } from "primereact/toast";

// Validation
import { LoginValidate } from "../../config/Validate";

// API
import axiosInstance from "../../config/axiosInstance";
import { LOGIN } from "../../config/ApiConstant";

// Buffer
import { Buffer } from "buffer";

interface FinalObj {
  email: string;
  password: string;
}

export const Login = () => {
  document.title = "Login | Nagra Accounting";

  const toast = useRef<any>(null);
  const navigate = useNavigate();
  const location = useLocation();

  // login data
  const [loginData, setLoginData] = useState<any>({});

  // error obj
  const [errors, setErrors] = useState<any>({});

  // loading
  const [loading, setLoading] = useState(false);

  // query parameter to get redirect url (for client)
  const queryParams = new URLSearchParams(location.search);

  // Handle input change
  const handleChange = (e: any, name: string) => {
    setLoginData({ ...loginData, [name]: e.target.value || "" });
    setErrors({ ...errors, [name]: "" });
  };

  // Handle submit
  const onSubmit = async () => {
    try {
      const { errors, isError } = LoginValidate(loginData);
      setErrors(errors);

      if (isError) return;

      setLoading(true);

      const payload: FinalObj = {
        email: loginData.email,
        password: Buffer.from(loginData.password).toString("base64"),
      };

      const response = await axiosInstance.post(LOGIN, payload);

      if (response) {
        const { token, user_data } = response?.data?.data;

        // Save Authorization
        axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;


        // Save local storage
        localStorage.setItem("token", token);
        localStorage.setItem("user_data", JSON.stringify(user_data));
        localStorage.setItem("menu_access", user_data?.menu_access);

        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response?.data?.message,
        });

        setTimeout(() => {
          let redirectPath = "/dashboard";

          if (user_data?.roles?.role_name === "Client") {
            const rawRedirect = queryParams.get("redirect");
            if (rawRedirect?.startsWith("/")) redirectPath = rawRedirect;
          }

          navigate(redirectPath);
        }, 500);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Login Failed",
        detail: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="login-layout">
        {/* Left Image Section */}
        <div className="login-left">
          <img src="/assets/images/login_image.png" alt="Login" className="login-image" />

          <div className="brand-overlay">
            <h2 className="brand-title">Nagra Accounting</h2>
            <p className="brand-subtitle">Secure access to your accounting dashboard.</p>
          </div>
        </div>

        {/* Right Login Section  */}
        <div className="login-right">
          <div className="login-panel p-fluid">
            <div className="brand-overlay">
              <h2 className="brand-title">Nagra Accounting</h2>
              <p className="brand-subtitle">Secure access to your accounting dashboard.</p>
            </div>
            <h2 className="login-heading">Login</h2>

            {/* EMAIL */}
            <div className="field">
              <span className="p-input-icon-left">
                <i className="pi pi-envelope"></i>
                <InputText
                  autoComplete="off"
                  value={loginData?.email || ""}
                  placeholder="Email"
                  onChange={(e) => handleChange(e, "email")}
                  className={errors.email && "p-invalid"}
                />
              </span>
              {errors.email && <small className="p-invalid-txt">{errors.email}</small>}
            </div>

            {/* PASSWORD */}
            <div className="field">
              <span className="p-input-icon-left">
                <i className="pi pi-key"></i>
                <Password
                  value={loginData?.password || ""}
                  placeholder="Password"
                  toggleMask
                  feedback={false}
                  autoComplete="current-password"
                  onChange={(e) => handleChange(e, "password")}
                  className={errors.password && "p-invalid"}
                />
              </span>
              {errors.password && <small className="p-invalid-txt">{errors.password}</small>}
            </div>

            {/* BUTTON */}
            <div className="login-btn ">
              <Button label="Login" loading={loading} onClick={onSubmit} className="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
